import {Button, Form, Modal, Progress, Space, Typography, Upload, UploadFile, UploadProps} from "antd";
import { useState } from "react";
import { useStore } from "../../config/store";
import { IClean } from "../../config/types";
import { showProgressTextOnHeavyFiles } from "../../utils/progressUtils";

export const UploadFinishFilesBlock = () => {
  const [error, setError] = useState("");
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const { loading, clean, cancelDrawer, uploadFinishCleanFiles, progressPercent, progressText, setProgressText } = useStore();
  const { id } = clean as IClean;
  const [form] = Form.useForm();

  const submitHandler = async (values: any) => {
    if (fileList.length > 0) {
      showProgressTextOnHeavyFiles(fileList, setProgressText);

      await uploadFinishCleanFiles({ clean_id: id, files: fileList, ...values });
      setProgressText("");
    } else {
      setError("Необходимо прикрепить фотографии");
    }
  };

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file, files) => {
      setFileList([...fileList, ...files]);
      return false;
    },
    fileList,
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Form
        form={form}
        onFinish={submitHandler}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item label="Загрузите результаты уборки. Фото загружать по одной фотографии.">
          <Modal
            open={loading}
            closable={false}
            footer={null}
            width={'fit-content'}
          >
            <Space direction="vertical" align="center" size="large" style={{ width: "100%" }}>
              <Progress
                percent={progressPercent}
                type="circle"
              />

              {progressText && <Typography.Text style={{ whiteSpace: "break-spaces" }}>{progressText}</Typography.Text>}
            </Space>
          </Modal>
          <div>
            <Upload {...props} listType="picture" style={{ width: "100%", display: "block" }} multiple>
              <Button
                block
              >
                Загрузить фото или видео
              </Button>
            </Upload>
          </div>
          {error && <div className="error">{error}</div>}
        </Form.Item>
        <Button
          type="primary"
          block
          size="large"
          htmlType="submit"
          loading={loading}
        >
          Загрузить фото
        </Button>
      </Form>
      <Button block size="large" onClick={cancelDrawer} loading={loading}>
        Отмена
      </Button>
    </Space>
  );
};
